// extracted by mini-css-extract-plugin
module.exports = {"signerForm":"styles_signerForm__BKv8B","disabledPill":"styles_disabledPill__R7_bh"};